import React from 'react';
import * as PropTypes from "prop-types";
import MyToggle from "./myToggle";

export const LabelToggle = React.forwardRef((props, ref) => (
    <div className="toggle">
        <label>
            <MyToggle ref={ref}
                      {...props}
                      checked={props.checked}
                      disabled={props.disabled}/>
            <span className={props.required ? "required" : ""}>{props.label}</span>
        </label>
    </div>
));

LabelToggle.defaultProps = {
    checked: false,
    disabled: false,
};

LabelToggle.propTypes = {
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
    required: PropTypes.bool,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    className: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    id: PropTypes.string,
    'aria-labelledby': PropTypes.string,
    'aria-label': PropTypes.string,
};

export default LabelToggle;